import { ProLayout } from '@ant-design/pro-components';
import { MenuOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Grid, Space, Typography } from 'antd';
import { useMemo } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AvatarDropdown, AvatarName } from '@/common/components';
import { useAppContext } from '@/common/hooks/AppStateProvider';
import { useOrganizationPath } from '@/common/hooks/use-organization-path';
import { buildMenuData } from '@/common/utils/route';

const APP_TITLE = 'CNT 文旅新媒体智能体';
const APP_HOME_PATH = '/';
const OWNER_ADMIN_ROLES = new Set(['owner', 'admin']);

const filterMenuRoutesByRole = (routes, role) => {
  return routes
    .filter((route) => !route.ownerAdminOnly || OWNER_ADMIN_ROLES.has(role))
    .map((route) => ({
      ...route,
      children: route.children ? filterMenuRoutesByRole(route.children, role) : undefined,
    }));
};

const resolveOrganizationMenuData = (items, resolvePath) => {
  return items.map((item) => ({
    ...item,
    path: resolvePath(item.path),
    routes: item.routes ? resolveOrganizationMenuData(item.routes, resolvePath) : undefined,
  }));
};

const AppLayout = ({ routes }) => {
  const screens = Grid.useBreakpoint();
  const location = useLocation();
  const navigate = useNavigate();
  const { session } = useAppContext();
  const { resolveOrganizationPath } = useOrganizationPath();
  const menuData = useMemo(() => {
    return resolveOrganizationMenuData(
      buildMenuData(filterMenuRoutesByRole(routes, session.role), { includeHidden: true }),
      resolveOrganizationPath,
    );
  }, [resolveOrganizationPath, routes, session.role]);
  return (
    <ProLayout
      title={APP_TITLE}
      headerTitleRender={
        screens.lg
          ? undefined
          : (logo) => (
              <Space size="small">
                {logo}
                <Typography.Text strong>CNT</Typography.Text>
              </Space>
            )
      }
      logo="/favicon.png"
      layout="top"
      disableMobile
      contentWidth="Fluid"
      location={location}
      route={{ routes: menuData }}
      menuItemRender={(item, dom) => (item.path ? <Link to={item.path}>{dom}</Link> : dom)}
      menuProps={{
        'aria-label': '主导航',
        triggerSubMenuAction: 'click',
        overflowedIndicator: <MenuOutlined aria-label="更多导航" />,
      }}
      actionsRender={() => [
        <AvatarDropdown key="user" menu>
          <Button aria-label="用户菜单" icon={<UserOutlined />} type="text">
            {screens.lg && <AvatarName />}
          </Button>
        </AvatarDropdown>,
      ]}
      footerRender={false}
      onMenuHeaderClick={() => navigate(resolveOrganizationPath(APP_HOME_PATH))}
    >
      <Outlet />
    </ProLayout>
  );
};
export default AppLayout;
